import React from 'react'
import styled from '@emotion/styled'
import { colors, MenuItem, Text } from 'ic-snacks'
import MoreMenu from 'legacy/components/MoreMenu'
import RowHeaderContainer from './RowHeaderContainer'
const RowHeader = styled(RowHeaderContainer)<{ even: boolean }>(({ even }) => ({
  background: even ? colors.WHITE : colors.GRAY_97,
  justifyContent: 'space-between',
  /* Bumps z-index up so ShiftHeader + MoreMenu overlay potential "closed" hours */
  zIndex: 2,
  flexShrink: 0,
}))

const menuItemStyle = {
  paddingTop: '8px',
  paddingBottom: '8px',
  fontSize: '12px',
}

const DELETE = 'delete'

interface Props {
  even: boolean
  children: React.ReactNode
  onDelete(): void
}

class ShiftHeader extends React.PureComponent<Props> {
  handleMoreSelect = (e: Event, selection: { value: string }) => {
    const { onDelete } = this.props

    e.stopPropagation()

    switch (selection.value) {
      case DELETE:
        onDelete()
        break
      default:
        throw new Error('Unsupported selection type!')
    }
  }

  render() {
    const { even, children } = this.props

    return (
      <RowHeader even={even}>
        <Text variant="T.14">{children}</Text>
        <MoreMenu onSelect={this.handleMoreSelect} margin={15}>
          <MenuItem
            style={{ ...menuItemStyle, color: colors.RED_500 }}
            label="Delete"
            value={DELETE}
          />
        </MoreMenu>
      </RowHeader>
    )
  }
}

export default ShiftHeader
